import { Stack } from "@mui/material";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive.ts";
import { entitiesUrl } from "src/utils/formatUrl";

import ConnectDynamicForm from "../../DynamicForm/ConnectDynamicForm.tsx";
import { CustomConnectProps } from "../../DynamicForm/context.ts";
import BackBtn from "../Common/BackBtn.tsx";
import LogoViewer from "../Common/ConnectStep/LogoViewer.tsx";
import ThemeContext from "../context.ts";
import Context from "./context";

// ----------------------------------------------------------------------

export const TransfersConnectStep = () => {
	const { state, actions, id, theme, themeType } = useContext(ThemeContext);
	const { actions: contextActions } = useContext(Context);
	const isMobile = useResponsive("down", "sm");

	const onConnect = (token: string) => {
		actions.setStep(3);
		contextActions.onConnectAccount(token);
	};

	const formProps: CustomConnectProps = {
		onConnect,
		theme,
		themeType,
		showSaveCheckbox: false
	};

	const bigHeight = state.entity?.id === "ing" || state.entity?.id === "renta4";

	return (
		<Stack minWidth={{ xs: 250, sm: 330 }} height={isMobile ? "auto" : bigHeight ? 550 : 500}>
			<BackBtn onClick={() => actions.setStep(1)} />
			<LogoViewer src={entitiesUrl(state.entity?.id ?? "")} />
			<ConnectDynamicForm id={id} entity={state.entity} customConnectProps={formProps} />
		</Stack>
	);
};

export default TransfersConnectStep;
